import * as React from 'react';
import { ValidationMessage } from './ValidationMessage';
import styled from 'styled-components';
import { IValidationSummary } from './IValidationSummary';

interface IValidationList {
  items: IValidationSummary[];
}

const StyledValidationList = styled.div`
  display: grid;
  gap: ${(props) => props.theme.spacing.spacing4};
  > * {
    margin-left: ${(props) => props.theme.spacing.spacing5};
  }
`;

export const ValidationList = ({ items }: IValidationList) => {
  return (
    <StyledValidationList>
      {items.map(({ items, message }, index) => (
        <React.Fragment key={index}>
          <ValidationMessage message={message} />
          {items && items.length > 0 ? <ValidationList items={items} /> : null}
        </React.Fragment>
      ))}
    </StyledValidationList>
  );
};
